import React from 'react'
import { PRESCRIPTION_BUILDER_VIEW_TYPES_ARRAY } from 'src/consumer/constants'
import { MPSettingsListItem } from '../../../styles'
import { Spinner } from 'react-bootstrap'

export default function PrescriptionEditorSettings({
  prescriptionViewSettings,
  setPrescriptionViewSettings,
  updatePrescriptionViewSettings,
  saveLoading,
}) {
  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <h5 style={{ marginBottom: '1.25rem', fontSize: '1.55rem' }}>Editor Layout Type</h5>
        <button
          className="btn btn-primary"
          style={{ margin: '0px 0px 26px' }}
          onClick={updatePrescriptionViewSettings}
          disabled={saveLoading}
        >
          Save {saveLoading && <Spinner animation="border" variant="light" size="sm" />}
        </button>
      </div>
      {PRESCRIPTION_BUILDER_VIEW_TYPES_ARRAY.map((viewType) => (
        <MPSettingsListItem
          key={viewType?.id}
          selected={prescriptionViewSettings?.prescriptionBuilderViewType === viewType.id}
          onClick={() =>
            setPrescriptionViewSettings((prev) => ({
              ...prev,
              prescriptionBuilderViewType: viewType.id,
            }))
          }
        >
          {viewType.title}
        </MPSettingsListItem>
      ))}
    </div>
  )
}
